import './Slider.scss';
import Component from './Slider.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);